import { render, staticRenderFns } from "./ConfigureStamp.vue?vue&type=template&id=3a0b4a42&scoped=true&"
import script from "./ConfigureStamp.vue?vue&type=script&lang=js&"
export * from "./ConfigureStamp.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureStamp.vue?vue&type=style&index=0&id=3a0b4a42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0b4a42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a0b4a42')) {
      api.createRecord('3a0b4a42', component.options)
    } else {
      api.reload('3a0b4a42', component.options)
    }
    module.hot.accept("./ConfigureStamp.vue?vue&type=template&id=3a0b4a42&scoped=true&", function () {
      api.rerender('3a0b4a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/shared/ConfigureStamp.vue"
export default component.exports